import { useDispatch } from 'react-redux';
import ProPageLayout from 'components/ProPageLayout';
import Coupon from 'types/Coupon';
import SignUpForm from 'components/SignUpForm';
import { variants } from 'utils/amplitudeHelper';
import { wrapUrlSafe } from '@alltrails/shared/utils/languageSupport';
import useLanguageRegionCode from '@alltrails/shared/hooks/useLanguageRegionCode';
import { setUser } from '../../userSlice';
import { setExperiments } from '../../experimentsSlice';

type Props = {
  coupon?: Coupon;
};

export default function RegisterRoute({ coupon }: Props) {
  const dispatch = useDispatch();
  const languageRegionCode = useLanguageRegionCode();

  return (
    <ProPageLayout>
      <SignUpForm
        handleRegistrationSuccess={async ({ user }) => {
          dispatch(setUser(user));

          const experiments = await variants(user);
          dispatch(setExperiments(experiments));

          const params = new URLSearchParams(__AT_DATA__.search);

          if (coupon) {
            params.set('k', coupon.code);
          }

          const search = params.toString();

          window.location.assign(wrapUrlSafe(`/plus/checkout${search ? `?${search}` : ''}`, languageRegionCode));
        }}
        useReactRouter
      />
    </ProPageLayout>
  );
}
